angular.module('impactx.catalog').directive('ixCatalogRuleInformation', function ()
{
    return {
        scope: {
            catalogRulesLabel: "@",
            checkRulesLabel: "@",
            infoRulesLabel: "@",
            statisticRulesLabel: "@",
            yesLabel: "@",
            noLabel: "@",
            catalogRuleCheckItems: "=",
            catalogRuleInfoItems: "=",
            catalogRuleStatisticItems: "="
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/templates/catalog-rule-information.html',
        transclude: true
    };
});